<!--
  创建时间：2024/11/20 下午5:56
  创建人：toyeh
  文件描述：ShopList
-->

<template>
  <div class="container" :style="{'--transformX': transformX}">
    <img src="@/assets/images/shop/banner.jpg" alt="长沙阳光采购分平台" class="banner">
    <div class="def-w">
      <ul class="tab-head flex-center">
        <li v-for="(ut,index) in unitTypeOption" :key="ut[code]" class="tab-item" :class="{active: unitType === ut[code]}" @click="chooseTab(ut[code], index)"> {{ ut[label] }}</li>
      </ul>
      <div class="shop-list-box">
        <div v-for="item in list" :key="item.id" class="shop-list-item flex-center mr-20 mb-20" @click="navDetail(item)">
          <div class="shop-item-img">
            <img :src="item.logo" :title="item.name" :alt="item.name">
          </div>
          <div class="shop-item-info">
            <div class="shop-item-title text-cut">{{ item.name }}</div>
            <div class="shop-item-desc"><span class="fc99">招标采购（项）：</span><span class="color-theme-red">{{ item.listingNumber || '/' }}</span></div>
          </div>
        </div>
      </div>
      <info-pagination
        single-page-hide
        :total="total"
        :current-page.sync="curPage"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getConstantDic, SELECT_OPTION_CONFIG, UNIT_TYPE_OPTIONS } from "@/utils/constant";
import InfoPagination from "@/components/InfoPagination.vue";
import platformApi from "@/api/platform";

export default {
  name: "ShopList",
  components: { InfoPagination },
  props: {
  },
  data() {
    return {
      unitTypeOption: getConstantDic(UNIT_TYPE_OPTIONS),
      unitType: UNIT_TYPE_OPTIONS.ALL[SELECT_OPTION_CONFIG.CODE],
      code: SELECT_OPTION_CONFIG.CODE,
      label: SELECT_OPTION_CONFIG.LABEL,
      transformX: "calc(-50% - 180px)",
      curPage: 1,
      pageSize: 15,
      total: 0,
      list: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList()
  },
  // 方法集合
  methods: {
    chooseTab(code, index) {
      this.unitType = code;
      this.curPage = 1
      this.transformX = `calc(-50%  + ${(index - 1) * 180}px)`;
      this.getList()
    },
    // 获取列表
    getList() {
      platformApi.page({
        pageNo: this.curPage,
        pageSize: this.pageSize,
        unitType: this.unitType
      }).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total
          this.list = list
        }
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.curPage = val
      this.getList()
    },
    navDetail(item) {
      if (item.link) {
        window.open(item.link, "_blank")
      } else if (item.status === 1) {
        const route = this.$router.resolve({
          path: "/shop/detail/fpt/" + item.id
        })
        window.open(route.href)
      } else {
        this.$alert("敬请期待", "友情提示")
      }
    }
  }
};
</script>

<style scoped lang="scss">
.banner{
	width: 100%;
	height: auto;
	display: block;
}
.tab-head{
	width: 100%;
	height: 100px;
	position: relative;
	.tab-item{
		width: 180px;
		text-align: center;
		font-size: 20px;
		cursor: pointer;
		&.active{
			font-weight: bold;
		}
	}
	&:after{
		content: '';
		display: block;
		position: absolute;
		left: 50%;
		bottom: 20px;
		width: 50px;
		height: 4px;
		border-radius: 2px;
		background: $--color-primary;
		transform: translateX(var(--transformX));
		overflow: hidden;
		transition: all 0.3s;
	}
}
.shop-list-box{
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	.shop-list-item{
		width: 386px;
		height: 110px;
		border: 1px solid #ddd;
		cursor: pointer;
		&:nth-of-type(3n){
			margin-right: 0;
		}
		&:hover{
			border-color: $--color-primary;
			box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
		}
		.shop-item-img{
			width: 82px;
			height: 82px;
			margin-right: 15px;
			text-align: center;
			line-height: 82px;
			font-size: 0;
			img{
				max-width: 100%;
				max-height: 100%;
				object-fit: contain;
				vertical-align: middle;
			}
		}
		.shop-item-info{
			width: 256px;
		}
	}
}
</style>
